
import { useLocation } from 'react-router-dom';
import ReadalMark from '../ReadalMark'
import { useState } from 'react';
export function Navbar () {
    const location = useLocation();

    return (
        <nav>
        <a href="/" className="logo-mark">
            <ReadalMark size={34} className="logo-icon" /> READAL SYSTEMS
        </a>
        <div className="nav-links">
            {
                location.pathname == "/portfolio" || location.pathname == "/contact" ? <a href="/">Home</a> :
                <>
                    <a href="#services">Services</a>
                    <a href="#solutions">Solutions</a>
                    <a href="#process">Process</a>
                    <a href="#why">Why Readal</a>
                    <a href="#testimonials">Testimonials</a>
                </>
            }
        </div>
        <div className="nav-cta-wrap">
            <a className="btn btn-ghost btn-sm magnetic" href="/portfolio">Portfolio</a>
            <a className="btn btn-primary btn-sm magnetic" href="/contact">Contact</a>
        </div>
        </nav>
    )
}